/* eslint-disable import/prefer-default-export */
export const CHANGE_BANDWIDTH_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
export const GET_BANDWIDTH_URL = 'https://slot.tizeti.com/geniatechapi/index.php';
